import { render } from "./ModalDeleteAdminPanelUser.vue?vue&type=template&id=c0095484"
import script from "./ModalDeleteAdminPanelUser.vue?vue&type=script&lang=js"
export * from "./ModalDeleteAdminPanelUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__